import '../styles/main.scss';
import 'bootstrap/dist/js/bootstrap.bundle';

// Import components
import Header from './dev/Components/Header';
import Footer from './dev/Components/Footer';
import Carousel from './dev/Components/Carousel';
import StandardContent from './dev/Components/StandardContent';
import Form from './dev/Components/Form';
import CollectionPanel from './dev/Components/CollectionPanel';
import QuickReader from './dev/Components/QuickReader';
import FeaturePanel from './dev/Components/FeaturePanel';
import VideoPanel from './dev/Components/VideoPanel';
import OverlayGallery from './dev/Components/OverlayGallery';
import NewsSearch from './dev/Components/NewsSearch';
import CareHomeList from './dev/Components/CareHomeList'; // Google maps - LocationMap.js
import VacanciesList from './dev/Components/VacanciesList'; // Google maps - LocationMap.js
import MapOtherCareHome from './dev/Components/MapOtherCareHome'; // Google maps - probably deprecated - LocationMap.js
import ContactPanel from './dev/Components/ContactPanel';
import CTAModal from './dev/Components/CTAModal';
import HeroPanel from './dev/Components/HeroPanel';
import SocialMedia from './dev/Components/SocialMedia';
import Shortlist from './dev/Components/Shortlist';
import Recent from './dev/Components/Recent';
import Tooltips from './dev/Components/Tooltips';
import LiveChat from './dev/Components/LiveChat';
import NearbyHomesModal from './dev/Components/NearbyHomesModal'; // Google maps - GoogleMap.js
import PaymentForm from './dev/Components/PaymentForm';
import VideoPanelInline from './dev/Components/VideoPanelInline';
import NearestHome from './dev/Components/NearestHome'; // user agent navigator, not GM
import SvgIcons from './dev/Components/SvgIcons';

$(() => {
  $('body').removeClass('nojs');
  try {
    document.createEvent('TouchEvent');
    $('body').addClass('touch');
  } catch (e) {
    // nothing
  }

  // eslint-disable-next-line no-undef
  if (typeof (objectFitImages) === 'function') {
    // eslint-disable-next-line no-undef
    objectFitImages(null, { watchMQ: true });
  }
  // Initiate components
  Header.init();
  Footer.init();
  // disbale modal closing on backdrop click
  $('.modal').attr('data-bs-backdrop', 'static');

  // Setup globally accessible modules that can be initialized inline via widgets as they're added.
  window.widgetModules = {};
  window.widgetModules.carousel = Carousel;
  window.widgetModules.form = Form;
  StandardContent.init();
  window.widgetModules.form.init();
  CollectionPanel.init();
  QuickReader.init();
  window.widgetModules.carousel.init();
  FeaturePanel.init();
  VideoPanel.init();
  OverlayGallery.init();
  CareHomeList.init();
  NewsSearch.init();
  VacanciesList.init();
  MapOtherCareHome.init();
  ContactPanel.init();
  CTAModal.init();
  HeroPanel.init();
  SocialMedia.init();
  Shortlist.init();
  Recent.init();
  Tooltips.init();
  LiveChat.init();
  NearbyHomesModal.init();
  PaymentForm.init();
  VideoPanelInline.init();
  NearestHome.init();
  SvgIcons.init();
  if (window.location.hash) {
    setTimeout(() => {
      (document.getElementById(window.location.hash.slice(1))).scrollIntoView({ behavior: 'instant' });
    }, 1500);
  }
});
